import { render, staticRenderFns } from "./u-card-flat-default.vue?vue&type=template&id=8b446878&scoped=true&"
import script from "./u-card-flat-default.vue?vue&type=script&lang=js&"
export * from "./u-card-flat-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b446878",
  null
  
)

export default component.exports